import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import DailyInspectionForm from "components/fleet/DailyInspectionForm";
import { CreateDailyFormInspectionInput } from "generated/graphql";
import useCreateDailyFormInspection from "hooks/fleet/useCreateDailyFormInspection";

export default function CreateDailyInspectionPage() {
  const navigate = useNavigate();
  const [createInspection, { loading: creating }] = useCreateDailyFormInspection();

  const handleFormSubmit = useCallback(
    async (data: CreateDailyFormInspectionInput) => {
      const result = await createInspection({
        variables: {
          input: data,
        },
      });

      if (result.data?.createDailyFormInspection) {
        navigate("/fleet/daily-inspections");
      }
    },
    [createInspection, navigate]
  );

  const handleCancel = useCallback(() => {
    navigate("/fleet/daily-inspections");
  }, [navigate]);

  return (
    <DashboardPage>
      <MDBox mb={3}>
        <MDTypography variant="h4" fontWeight="medium">
          Create Daily Inspection
        </MDTypography>
      </MDBox>

      <MDBox>
        <DailyInspectionForm
          type="create"
          onSubmit={handleFormSubmit}
          onCancel={handleCancel}
          loading={creating}
        />
      </MDBox>
    </DashboardPage>
  );
}
